import React from 'react'

import discover_persona from '../../assets/images/mains/discoverPersona.svg';
import identify_visitor from '../../assets/images/mains/identifyVisitor.svg';
import predict_Intent from '../../assets/images/mains/predictIntent.svg';
import targeted_offers from '../../assets/images/mains/targetOffer.svg';
import boost_ltv from '../../assets/images/mains/chatbot.svg';

const HowItWorks = () => {
  const working = {
    Identify_Visiors : {
      icon: identify_visitor,
      title: "Identify Visitor",
      desc: "Our data pipeline is a ground-breaking anonymous visitor categorization and classification platform that does not rely on cookies.",
      cls: "working-item-left",
      // bg: "#fef1f2",
      bg: "#ebfbff",
      sno: 1,
      // snoColor: "#e64655",
      snoColor: "#00d2fc",
      // animationClass: 'scale-in-hor-center',
    },
    Predict_Intent : {
      icon: predict_Intent,
      title: "Predict Intent",
      desc: "Our proprietary AI models predict every visitor's intent to buy with great accuracy using our cookie-agnostic platform.",
      cls: "working-item-right",
      // bg: "#f2edff",
      bg: "#ebfbff",
      sno: 2,
      // snoColor: "#6a35ff",
      snoColor: "#00d2fc",
      // animationClass: 'scale-in-hor-center',
    },
    Discover_Persona : {
      icon: discover_persona,
      title: "Discover Persona",
      desc: "Our behavior models help you discover the visitor persona, like exploratory shoppers, returning visitors, discount buyers etc.",
      cls: "working-item-left",
      bg: "#ebfbff",
      sno: 3,
      snoColor: "#00d2fc",
      // animationClass: 'scale-in-hor-center',
    },
    Targeted_Offers : {
      icon: targeted_offers,
      title: "Targeted Offers",
      desc: "Powered with buying intent and persona we show targeted offers to the visitors in real-time when they are about to abandon your site and lead them to convert.",
      cls: "working-item-right",
      // bg: "#fff1cc",
      bg: "#ebfbff",
      sno: 4,
      // snoColor: "#6a35ff",
      snoColor: "#00d2fc",
      // animationClass: 'scale-in-hor-center',
    },
    Boost_LTV : {
      icon: boost_ltv,
      title: "Boost Life Time Value",
      desc: "Using our LTV AI Engine, improve the life time value of existing cusotmers by combining your anonymous and historical data.",
      cls: "working-item-left",
      // bg: "#fff1cc",
      bg: "#ebfbff",
      sno: 5,
      // snoColor: "#6a35ff",
      snoColor: "#00d2fc",
      // animationClass: 'scale-in-hor-center',
    },
  }
  return (
    <div className='working-container container my-3'>
        <h2 className='section-title text-center '> How It Works?</h2>
        <div className='flex-col work-steps w-100 working'>
          <WorkItem 
            icon={working.Identify_Visiors.icon} 
            bg={working.Identify_Visiors.bg} 
            cls={working.Identify_Visiors.cls} 
            title={working.Identify_Visiors.title} 
            desc={working.Identify_Visiors.desc}
            sno={working.Identify_Visiors.sno}
          snoColor={working.Identify_Visiors.snoColor}
          // animationClass={working.Identify_Visiors.animationClass}
          />
          <WorkItem 
            icon={working.Predict_Intent.icon} 
            bg={working.Predict_Intent.bg} 
            cls={working.Predict_Intent.cls} 
            title={working.Predict_Intent.title} 
            desc={working.Predict_Intent.desc}
            sno={working.Predict_Intent.sno}
          snoColor={working.Predict_Intent.snoColor}
          // animationClass={working.Predict_Intent.animationClass}
          />
          <WorkItem 
            icon={working.Discover_Persona.icon} 
            bg={working.Discover_Persona.bg} 
            cls={working.Discover_Persona.cls} 
            title={working.Discover_Persona.title} 
            desc={working.Discover_Persona.desc}
            sno={working.Discover_Persona.sno}
          snoColor={working.Discover_Persona.snoColor}
          // animationClass={working.Discover_Persona.animationClass}
          />
          <WorkItem 
            icon={working.Targeted_Offers.icon} 
            bg={working.Targeted_Offers.bg} 
            cls={working.Targeted_Offers.cls} 
            title={working.Targeted_Offers.title} 
            desc={working.Targeted_Offers.desc}
            sno={working.Targeted_Offers.sno}
          snoColor={working.Targeted_Offers.snoColor}
          // animationClass={working.Targeted_Offers.animationClass}
          />
          <WorkItem 
            icon={working.Boost_LTV.icon} 
            bg={working.Boost_LTV.bg} 
            cls={working.Boost_LTV.cls} 
            title={working.Boost_LTV.title} 
            desc={working.Boost_LTV.desc}
            sno={working.Boost_LTV.sno}
          snoColor={working.Boost_LTV.snoColor}
          // animationClass={working.Boost_LTV.animationClass}
          />
        </div>
    </div>
  )
}

export default HowItWorks


export const WorkItem = (props) => {
  const { icon, bg, cls, title, desc, sno, snoColor, animationClass } = props;
  return (
    // <div className={` work-item my-3 ${cls}`}  x-intersect="$el.classList.add('scale-parallax')" style={{backgroundColor:bg}}>
    <div className={` work-item my-3 ${cls}`}  style={{backgroundColor:bg}}>
          <div className='work-content'>
            <h3 className='work-title'>{title}</h3>
            <p className='work-desc'>{desc}</p>
          </div>
          <div className='work-item-no' style={{color:snoColor, display:"flex"}}>
            {sno}
          </div>
          <div className='work-icon-container'>
            <img className='img img-fluid work-icon' src={icon} alt=""/>
          </div>
        </div>
    )
}